module.exports = __webpack_public_path__ + "img/cog.d26cdbec.png";